"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.anchorComponentInstance = exports.AnchorComponent = void 0;
const app_1 = require("app");
class AnchorComponent extends app_1.Component {
    OnInit() {
        setTimeout(() => {
            this.checkHash();
            // timeout to complete react header rendering and header animation in ie
        }, 400);
    }
    OnHashChange() {
        this.checkHash();
    }
    checkHash() {
        app_1.scrollService.GoToAnchor(window.location.hash);
    }
}
exports.AnchorComponent = AnchorComponent;
exports.anchorComponentInstance = new AnchorComponent();
